import * as Actions from 'actionTypes';

const results = (state: Object = { isLoading: true }, action: Object) => {
  if (action.type === Actions.ADD_RESULTS_FAILED) {
    const newState = Object.assign({}, state);
    newState.isLoading = false;
    return newState;
  } else if (
    action.type === Actions.FETCH_RESULTS ||
    action.type === Actions.FETCH_INITIAL_RESULTS
  ) {
    const newState = Object.assign({}, state);
    newState.isLoading = true;
    newState.url = action.url;
    return newState;
  } else if (
    action.type === Actions.ADD_RESULTS ||
    action.type === Actions.ADD_INITIAL_RESULTS
  ) {
    return {
      ...state,
      isLoading: false,
      url: state.url,
      ...action.results
    };
  } else if (action.type === Actions.CHECK_POSTCODE) {
    const newState = Object.assign({}, state);
    newState.isLoading = false;
    return newState;
  }

  return state;
};

export default results;



// WEBPACK FOOTER //
// ./src/reducers/results.reducer/index.js